module.exports = { apiServer: 'https://api.azure.intimex.hk', AdminServer: 'https://admin.azure.eventizer.hk/', env: 'prod' };
